import datePicker from '@/components/date-picker'
import siteAppBar from '@/components/site-app-bar'
import siteNav from '@/components/site-nav'

import groupSelector from '@/components/group-selector'

import fueltypeChip from '@/components/fueltype-chip'

import googleMap from '@/components/google-maps/map'
import googleMapMarker from '@/components/google-maps/marker'
import googleMapControl from '@/components/google-maps/control'
import googleMapAutocomplete from '@/components/google-maps/autocomplete'
import googleMapCircle from '@/components/google-maps/circle'

const map = {
  'date-picker': datePicker,
  'site-app-bar': siteAppBar,
  'site-nav': siteNav,
  'google-map': googleMap,
  'google-map-marker': googleMapMarker,
  'google-map-control': googleMapControl,
  'google-map-autocomplete': googleMapAutocomplete,
  'google-map-circle': googleMapCircle,
  'group-selector': groupSelector,
  'fueltype-chip': fueltypeChip
}

export default Vue => {
  Object.entries(map).forEach(([key, component]) => {
    Vue.component(key, component)
  })
}
